<template>
  <div>
    <section>
      <!-- Title -->
      <div class="title">
        <h1>Dashboard</h1>
        <div class="clearfix"></div>
      </div>
      <!-- Main Content -->
      <div class="main-content">

        <div class="row">
          <div class="col-md-2" align="left">
            <button
              class="btn btn-filters"
              type="button"
              data-toggle="collapse"
              data-target="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              <i class="fas fa-filter"></i> Filtros
            </button>
            
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-filters"
              type="button"
              @click="getEntity"
            >
              <i class="fas fa-sync-alt"></i> Atualizar
            </button>
          </div>
          <div class="col-md-8" align="right" style="margin-top: -10px; font-size: 18px">
            Tamanho da Tabela: {{ size.size }} Mb
          </div>
        </div>

        <div class="row collapse mb-3" id="collapseExample">
          <div class="col-md-6">
            <label>Filtrar Destinatário</label>
            <input type="text" class="form-control" v-model="filters.destination">     
          </div>
          <div class="col-md-6">
            <label>Filtrar Assunto</label>
            <input type="text" class="form-control" v-model="filters.subject">     
          </div>
          <div class="col-md-4 mt-2">
            <label>Status</label>
            <v-select
              :options="status"
              label="name"
              :reduce="(status) => status"
              multiple
              class="style-chooser"
              v-model="filters.status"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-4 mt-2">
            <label>Data Início</label>
            <input type="datetime-local" class="form-control " v-model="filters.date_start">
          </div>
          <div class="col-md-4 mt-2">
            <label>Data Final</label>
            <input type="datetime-local" class="form-control" v-model="filters.date_end" >
          </div>
          <div class="col-md-12 mt-4 mb-3" align="center">
            <button class="btn btn-add" @click="getEntity()">
              Pesquisar
            </button>
          </div>
        </div>

        <div class="row" v-if="!isLoading">
          <div class="col-md-12">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Destinatário</th>
                  <th scope="col">Assunto</th>
                  <th scope="col">Recebido em</th>
                  <th scope="col">Tipo Evento</th>
                  <th scope="col">Timestamp</th>
                  <th scope="col">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="event in events" :key="event.id">
                  <td>{{ event.id }}</td>
                  <td>{{ event.destination }}</td>
                  <td>{{ event.subject }}</td>
                  <td>{{ event.created_at }}</td>
                  <td>{{ event.event_type }}</td>
                  <td>{{ event.timestamp }}</td>
                  <td><button class="btn btn-add" @click="openModal(event)">Visualizar JSON</button></td>
                </tr>
                <tr>
                  <td colspan='7' align="center" v-if="events.length == 0">Nenhum registro encontrado</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>  
        <div
              class="row justify-content-center"
              align="center"
              style="padding: 15px"
            >
              <div class="col-md-12">
                <pagination
                  :records="total"
                  :options="options"
                  :per-page="20"
                  @paginate="getEntity"
                ></pagination>
              </div>
            </div>
      </div>

    </section>

<div class="modal fade" id="modalEvent" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered  modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">JSON Completo da Notificação</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <json-viewer :value="event_modal.original_json"   :expand-depth=5
  copyable
  boxed
  sort></json-viewer>
        <!-- {{ event_modal.original_json }} -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Pagination } from "vue-pagination-2";

export default {
  data() {
    return {
      size: {},
      fullPage: true,
      isLoading: true,
      filters: {},
      events: [],
      event_modal: {},
      total: 0,
      status: [],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
    };
  },
  computed: {},
  methods: {
    getEntity: function (page) {
      const self = this;
      const api = self.$store.state.api + "dashboards/?page=" + page;
      self.isLoading = true;

      self.$http
        .post(api, self.filters)
        .then((response) => {
          self.events = response.data.data;
          self.total = response.data.total;
          self.getSize();
          self.isLoading = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getStatus: function () {
      const self = this;
      const api = self.$store.state.api + "dashboards/status";

      self.$http
        .post(api, self.filters)
        .then((response) => {
          self.status = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSize: function () {
      const self = this;
      const api = self.$store.state.api + "dashboards/size";

      self.$http
        .post(api, self.filters)
        .then((response) => {
          self.size = response.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    openModal(obj){
      const self = this;

      self.event_modal = obj;

      $('#modalEvent').modal('show');

    }
  },
  components: { vSelect, Loading, Pagination },
  props: {},
  mounted: function () {
    this.getEntity();
    this.getStatus();
  },
};
</script>
<style scoped>
/* min-width */
@media screen and (min-width: 900px) {
  .margin-home {
    margin-top: -20px;
  }
}
#Chart1 {
  height: 300px;
  max-width: 100%;
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue